export const CityModel = [
  {
    key: "code",
    dataType: String,
  },
  {
    key: "name",
    dataType: String,
  },
  {
    key: "uid",
    dataType: String,
  },
  {
    key: "state",
    dataType: String,
  },
  {
    key: "status",
    dataType: Boolean,
  },
];
